// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsvg[data-v-ffd8e8ec] {\n  font-family: sans-serif;\n}\n[data-v-ffd8e8ec] .chart-label{\n  font-size:12px;\n  opacity:0.5;\n}\n[data-v-ffd8e8ec] .plot.highlighting .bar{\n  opacity: 0.2;\n}\n[data-v-ffd8e8ec] .plot.highlighting .bar.on{\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
